import { render, staticRenderFns } from "./ListOpportunities.vue?vue&type=template&id=54656988&scoped=true&"
import script from "./ListOpportunities.vue?vue&type=script&lang=js&"
export * from "./ListOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54656988",
  null
  
)

export default component.exports